import script from "./SendGridLog.vue?vue&type=script&setup=true&lang=js"
export * from "./SendGridLog.vue?vue&type=script&setup=true&lang=js"

import "./SendGridLog.vue?vue&type=style&index=0&id=59ed2bc0&scoped=true&lang=scss"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59ed2bc0"]])

export default __exports__